module.exports = new __parcel__URL__("dams.51f70e31.jpg").toString();